export default "/images/supplier_creadit.png?bbd55ddba1355ba1fd67d5812c065474";